import { useEffect, useRef, useState } from 'react';
import { ArrowUpRight, LogOut, UserRound } from 'lucide-react';
import { PageHeader } from '../components/ui';
import { useConsole } from '../state/ConsoleProvider';
import { messageFor } from '../lib/live';
import { publicWebsiteUrl } from '../lib/config';

export default function Account() {
  const { account, refreshAccount, signOut } = useConsole();
  const [pending, setPending] = useState<'refresh' | 'signout' | null>(null);
  const [error, setError] = useState('');
  const current = useRef(true);
  useEffect(() => { current.current = true; return () => { current.current = false; }; }, []);
  if (!account) return null;

  async function run(action: 'refresh' | 'signout') {
    if (pending) return;
    setPending(action);
    setError('');
    try { await (action === 'refresh' ? refreshAccount() : signOut()); }
    catch (cause) { if (current.current) setError(messageFor(cause, action === 'refresh' ? 'Your account could not be refreshed. Try again.' : 'Sign out could not be completed. Try again.')); }
    finally { if (current.current) setPending(null); }
  }

  return <>
    <PageHeader eyebrow="YOUR ROTEN ACCOUNT" title="Account" description="Your account details and console access." actions={<button className="button button-secondary" disabled={pending !== null} onClick={() => void run('refresh')}>{pending === 'refresh' ? 'Refreshing…' : 'Refresh details'}</button>} />
    {error && <p className="live-account-error" role="alert">{error}</p>}
    <div className="account-layout">
      <section className="panel account-profile" aria-labelledby="account-heading">
        <div className="panel-header"><div className="account-section-heading"><UserRound size={19} /><h2 id="account-heading">Account details</h2></div></div>
        <dl className="live-account-details"><div><dt>Name</dt><dd>{account.name || 'Not provided'}</dd></div><div><dt>Username</dt><dd className="mono">{account.username}</dd></div><div><dt>Email address</dt><dd>{account.email || 'Not provided'}</dd></div></dl>
        <p className="live-account-note">Contact Roten if you need to update these details.</p>
      </section>
      <section className="panel live-info-card"><h2>Console access</h2><p>Roten staff manage passwords. Contact Roten if you need a password change or help signing in.</p><p>Sign out when you finish using the console on a shared device.</p><button className="button button-secondary" disabled={pending !== null} onClick={() => void run('signout')}><LogOut size={15} />{pending === 'signout' ? 'Signing out…' : 'Sign out'}</button><a className="text-link" href={`${publicWebsiteUrl}/contact`} target="_blank" rel="noreferrer">Contact Roten <ArrowUpRight size={14} /></a></section>
    </div>
  </>;
}
